import { Attachment } from "../../../../Participants/ParticipantSubTabs/Attachment/Attachment";

export const ShuduleAttachment = ({ dataa, loadinggg, userinfo }) => {
  return (
    <>
      <Attachment dataa={dataa} loadinggg={loadinggg} userinfo={userinfo} />
    </>
  );
};
